import { Checkbox, DataSource, ExcludableTextbox, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSalesPipelineReport extends Layout {
    checkboxIncludeAwardedOpportunities: Checkbox;
    checkboxIncludeItemsWithoutCloseDates: Checkbox;
    checkboxIncludeNoSalesStatus: Checkbox;
    checkboxIncludeZeroDollarPotential: Checkbox;
    checkboxPageBreak: Checkbox;
    excludabletextboxCustomerId: ExcludableTextbox;
    excludabletextboxProspectTypeId: ExcludableTextbox;
    excludabletextboxSalesManagerId: ExcludableTextbox;
    excludabletextboxSalesStatusId: ExcludableTextbox;
    excludabletextboxSalespersonId: ExcludableTextbox;
    sourceSalesPipelineReport: DataSource;
    textboxCustomerProspect: Textbox;
    textboxGroupBy: Textbox;
    textboxMinConfidenceLevel: Textbox;
    textboxProspectsOpportunities: Textbox;
    textboxSecondarySortBy: Textbox;
    textboxSortBy: Textbox;
}
